import { GeomSymsService } from './../../../services/geom-syms.service';
import { PopupSelectInputComponent } from './../../popup-select-input/popup-select-input.component';
import { SelectOption } from './../../dialogs/modal-select-dialog/modal-select-dialog.service';
import { LayerGeomTypeStrings } from './../../../model/sl-layer';
import { LayerGeomtypes } from 'src/app/model/sl-layer';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, AfterContentInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-symbol-selector',
  templateUrl: './symbol-selector.component.html',
  styleUrls: ['./symbol-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SymbolSelectorComponent implements AfterContentInit {
  private _ready = false;
  private _geomType: LayerGeomTypeStrings | string = 'unknown';
  @Input()
  set geotype(type: LayerGeomTypeStrings | string) {
    this._geomType = type;
    this.Refresh();
  }
  get geom(): LayerGeomTypeStrings | string {
    return this._geomType;
  }
  private _val: string = 'default';
  @Input()
  public set value(val: string) {
    this._val = val;
    this.Refresh();
  }
  public get value(): string {
    return this._val;
  }
  @Output()
  public valueChange = new EventEmitter<string>();

  private _label = '';
  public set label(lbl:string) {
    this._label = lbl;
    this.Refresh();
  }
  public get label():string {
    return this._label;
  }

  GetPointOptions(_input: PopupSelectInputComponent): Array<SelectOption> {
    return this.syms.GetOptionProvider('point');

  }
  GetLineOptions(_input: PopupSelectInputComponent): Array<SelectOption> {
    return this.syms.GetOptionProvider('line');
  }
  GetPolygonOptions(_input: PopupSelectInputComponent): Array<SelectOption> {
    return this.syms.GetOptionProvider('polygon');
  }
  GetSymbolDefault() {
    return 'default';
  }

  GetDefaultSize() {
    return '3';
  }

  constructor(private cdr: ChangeDetectorRef, private syms: GeomSymsService) { }

  ngAfterContentInit(): void {
    this._ready = true;
  }

  NotifyListeners() {
    this.valueChange.emit(this.value);
  }

  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }

}
